import { isRecord } from '#layers/base/utils/object';

export function maybeResponseError(error: unknown): unknown {
	if (isRecord(error) && 'data' in error) {
		return error.data ?? error;
	}

	return error;
}
